import AssignmentDeleteButton from "./AssignmentDeleteButton";
import AssignmentDeleteCancelButton from "./AssignmentDeleteCancelButton";

interface ModalFooter {
  closeDeleteModal: () => void;
}

const ModalFooterActions = ({ closeDeleteModal }: ModalFooter) => (
  <>
    <AssignmentDeleteCancelButton closeDeleteModal={closeDeleteModal} />
    <AssignmentDeleteButton closeDeleteModal={closeDeleteModal} />
  </>
);

export default ModalFooterActions;
